export default "__VITE_ASSET__Cs7FK2Nw__"